import { MaybeDate } from "../../entities/common";
import { CalendarDataSet } from "../../store/calendar/common";
import { calculateDateVariance } from "../../store/project/utils";

// the same is in KeyDateVarianceCalculator.cs on server side
export class KeyDateVarianceCalculator {
    public static CalculateDateVariance(keyDateDate: MaybeDate, keyDateBaslineDate: MaybeDate, calendar: CalendarDataSet): number | undefined {
        return calculateDateVariance(keyDateDate, keyDateBaslineDate, calendar);
    }
}